import React, { useEffect, useState } from "react";

import {
  GridColumnGroupingModel,
  GridAlignment,
} from "@mui/x-data-grid-premium";

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Chip,
  Divider,
  Fade,
  Grid,
  Paper,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  Button,
  Typography,
  CircularProgress,
  Popover,
} from "@mui/material";
import RulesListDataTable from "../../components/DataGrids/RulesListDataGrid";
import { pieData } from "../../services/constants/results";
import {
  RemoveTextAndSanatizedCode,
  formattedJson,
  getDateFromTimestamp,
  getFormattedTime,
  getSanatizedCode,
  getTimeInHHMMSS,
  formatNumberWithCommas,
  getSecondaryMergeResourceName,
  getSecondaryMergeResources,
  SECONDARY_MERGE_RESOURCES_KEY,
} from "../../services/utils";
import {
  downloadFileSecurely,
  getSecureValidationReportPath,
} from "../../services/fileDownloadService";
import {
  IconBoltType,
  IconWatchSvg,
  IconCheckCircleIconGreenSvg,
  IconCrossCircleIconSvg,
  IconFalsePositive,
  IconReRunWhite,
  IconDbInfo,
  IconSecondaryResourceSvg,
} from "../../common/utils/icons";
import { GridExpandMoreIcon } from "@mui/x-data-grid";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import CustomAccordion from "../../components/Molecules/Accordian/CustomAccordion";
import ResourceSupportDocuments from "../../components/Organisms/ResourceSupportDocuments";
import AdhocQueryDashboardTab from "../../components/Rules/AdhocQueryDashboardTab";
import RootCauseAnalysis from "../../components/Rules/RootCauseAnalysis";
import Incidents from "../../components/Rules/Incidents";
import Loader from "../../components/Molecules/Loader/Loader";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import ComparisonDashboardCard from "../../components/Rules/ComparisonDashboardCard";
import {
  brand,
  navyScale,
  blueScale,
  scssTokens,
  darkModeTokens,
  getPremiumCardSx,
} from "../../styles/Theme";
import { useThemeMode } from "../../contexts/ThemeModeContext";
import { resolveAdhocQueryRecordCount } from "../../components/Rules/adhocQueryCount";
import { getExecutionSubGroupName } from "../../utils/executionGroup";
import useExecutionSubGroupMap from "../../hooks/useExecutionSubGroupMap";

const ComparisonDetailedExecutionDashboard = ({
  dashboardData,
  isLoading,
  setIsLoading,
  isBackdropLoading,
  currentRuleResultId,
  currentRuleIncidentData,
  setIsTriggereBtnPressed,
  setIsCommentBtnPressed,
}: any) => {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const { mode } = useThemeMode();
  const isDark = mode === "dark";
  const executionSubGroupMap = useExecutionSubGroupMap();
  const canRuleExecution = hasPermission("rule", "execute");
  const canEditRuleExecutionIssues = hasPermission(
    "rule_execution_issues",
    "edit",
  );
  const [selectedTab, setSelectedTab] = useState<any>("missingRecords");
  const [columnsData, setColumnsData] = useState<any>({});
  const [rowsData, setRowsData] = useState<any>({});
  const [missingColumns, setMissingColumns] = useState<any>([]);
  const [mismatchedColumns, setMismatchedColumns] = useState<any>([]);
  const [missingCounts, setMissingCounts] = useState({
    keyCount: 0,
    resourceCount: 0,
  });
  const [downloadingFiles, setDownloadingFiles] = useState<Set<string>>(
    new Set(),
  );
  const [dbInfoAnchorEl, setDbInfoAnchorEl] = useState<HTMLElement | null>(
    null,
  );

  const handleDbInfoClick = (event: React.MouseEvent<HTMLElement>) => {
    setDbInfoAnchorEl(event.currentTarget);
  };

  const handleDbInfoClose = () => {
    setDbInfoAnchorEl(null);
  };

  const isDbInfoPopoverOpen = Boolean(dbInfoAnchorEl);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedTab(newValue);
    setMismatchedColumns([]);
    setMissingColumns([]);
  };

  const getFormattedKeysPairs = (
    inputString: string | undefined,
    type?: "missing",
  ) => {
    const pairs: any = {};

    // Check if inputString is defined and is a string
    if (inputString && typeof inputString === "string") {
      inputString.split(",").forEach((pair) => {
        if (pair.trim() !== "None") {
          const [key, value] = pair.trim().split("=");
          pairs[key] = getSanatizedCode(value);
        }
      });
    }

    if (type === "missing") {
      const count = Object.keys(pairs).length;
      setMissingCounts((prev) => ({
        ...prev,
        keyCount: count,
      }));
    }

    return pairs;
  };

  const getFormattedKeysPairs2 = (inputString: string, type?: "missing") => {
    const pairs: any = {};

    if (inputString && typeof inputString === "string") {
      inputString.split(",").forEach((pair) => {
        const [key, value] = pair.trim().split("=");

        if (key && value !== undefined) {
          pairs[key] = getSanatizedCode(value, ";");
        }
      });
    }

    if (type === "missing") {
      const count = Object.keys(pairs).length;
      setMissingCounts((prev) => ({
        ...prev,
        keyCount: count,
      }));
    }

    return pairs;
  };

  const getFormattedKeysPairs1 = (
    missing_in: any,
    false_positive_missings: any,
    resource_prefixes: any,
    type?: "missing",
  ) => {
    const pairs: any = {};
    if (!missing_in || !resource_prefixes) return {};

    const secondaryMergeResources = getSecondaryMergeResources(
      false_positive_missings,
    );

    resource_prefixes.forEach((prefix: string) => {
      if (getSecondaryMergeResourceName(secondaryMergeResources, prefix)) {
        pairs[prefix] = "secondaryfulfilled";
        return;
      }
      pairs[prefix] = missing_in.includes(prefix)
        ? false_positive_missings[prefix]
          ? "falsepositive"
          : "falsenegative"
        : "truepositive";
    });
    pairs[SECONDARY_MERGE_RESOURCES_KEY] = secondaryMergeResources;
    if (type === "missing") {
      setMissingCounts((prev) => ({
        ...prev,
        resourceCount: resource_prefixes.length,
      }));
    }
    return pairs;
  };
  const reverseFormattedKeysPairs = (inputObject: any) => {
    const desiredOutput = Object.entries(inputObject)
      .filter(([key]) => key !== "id")
      .map(([key, value]) => `${key}=${value}`)
      .join(", ");
    return desiredOutput;
  };

  const handelRowData = (comparison_rule_exec_details: any) => {
    const rows: any = [];
    const checkNames: any = [];

    comparison_rule_exec_details?.forEach((item: any) => {
      checkNames.push(item?.check_name);
      item?.errors?.row_details?.forEach((rowItem: any, idx: any) => {
        const row: any = {
          id: idx,
          ...getFormattedKeysPairs(rowItem?.keys),
          ...getFormattedKeysPairs2(rowItem?.file_names),
        };
        rows.push(row);
      });
    });
    let updatedRows: any = [];
    let newRow: any = {};

    comparison_rule_exec_details?.forEach((item: any) => {
      item?.errors?.row_details?.forEach((rowItem: any) => {
        const keysTrimmed = rowItem.keys.replace(/\s+/g, "");
        const fileNameTrimmed = rowItem.file_names;

        const mergedKeyData = keysTrimmed + "," + fileNameTrimmed;
        const row = rows.find((row: any) => {
          const rowKeysTrimmed = reverseFormattedKeysPairs(row).replace(
            /\s+/g,
            "",
          );
          const sanitizedMergedKeyData = mergedKeyData
            .replace(/['"]+/g, "")
            .replace(/\s+/g, "")
            .replace(/,None/g, "")
            .replace(/,undefined/g, "")
            .replace(/;/g, "");
          const sanitizedRowKeysTrimmed = rowKeysTrimmed
            .replace(/['"]+/g, "")
            .replace(/\s+/g, "")
            .replace(/<ul.*?>|<\/ul>|<li.*?>|<\/li>|<div.*?>|<\/div>/g, "");

          return (
            getSanatizedCode(sanitizedMergedKeyData) ===
            getSanatizedCode(sanitizedRowKeysTrimmed)
          );
        });
        newRow = {
          ...row,
          [item?.check_name]: rowItem?.column_values || "",
        };
        updatedRows.push(newRow);
      });
    });

    function mergeObjectsByKey(arr: any) {
      const mergedMap = new Map();

      arr.forEach((obj: any) => {
        // Create a composite key that includes all field values to ensure uniqueness
        // This prevents merging rows that have the same key fields but different data values
        const allFieldsKey = Object.keys(obj)
          .sort()
          .map((k: any) => `${k}:${obj[k]}`)
          .join("|");

        if (!mergedMap.has(allFieldsKey)) {
          mergedMap.set(allFieldsKey, { ...obj });
        }
      });
      return Array.from(mergedMap.values());
    }
    const mergedData = mergeObjectsByKey(updatedRows);
    const processedRows: any = processRows(mergedData);
    setRowsData((prev: any) => ({
      ...prev,
      mismatched:
        processedRows &&
        processedRows.map((item: any, idx: any) => ({
          ...item,
          id: idx,
        })),
    }));
  };

  const getColumns = (comparison_rule_exec_details: any) => {
    const firstColumns: any = Object.keys(
      getFormattedKeysPairs(
        comparison_rule_exec_details[0]?.errors?.row_details[0]?.keys,
      ),
    );
    const secondColumns: any = comparison_rule_exec_details?.map(
      (item: any) => item?.check_name,
    );
    const fileColumns: any = Object.keys(
      getFormattedKeysPairs(
        comparison_rule_exec_details[0]?.errors?.row_details[0]?.file_names,
      ),
    );
    const columnFirst: any = [...firstColumns].map((item: any) => {
      return {
        field: item,
        headerName: getSanatizedCode(item),
        flex: 1,
        minWidth: 110,
        renderCell: (params: any) => {
          return (
            <div className="long-string-width">
              {RemoveTextAndSanatizedCode(params.value, "Mismatched_", "")}
            </div>
          );
        },
      };
    });
    const columnSecond: any = [...secondColumns].map((item: any) => {
      return {
        field: item,
        headerName: getSanatizedCode(item),
        flex: 1,
        minWidth: 320,
        renderCell: (params: any) => {
          return (
            <div className="long-string-width">
              {RemoveTextAndSanatizedCode(params.value, "Mismatched_", "")}
            </div>
          );
        },
      };
    });
    const columnFile: any = [...fileColumns].map((item: any) => {
      return {
        field: item,
        headerName: getSanatizedCode(item),
        flex: 1,
        minWidth: 240,
        // renderCell: (params: any) => {
        //   return (
        //     <div className="long-string-width">
        //       {RemoveTextAndSanatizedCode(params.value, "Mismatched_", "")}
        //     </div>
        //   );
        // },
        renderCell: (params: any) => (
          <div
            className="data-grid-cell"
            dangerouslySetInnerHTML={{ __html: params.value }}
          />
        ),
      };
    });

    setColumnsData((prev: any) => ({
      ...prev,
      mismatched: [...columnFirst, ...columnSecond, ...columnFile],
    }));
  };
  const columnGroupingModel: GridColumnGroupingModel = [
    {
      groupId: "Keys",
      headerName: "Keys",
      headerAlign: "center",
      children: [
        { field: "id" },
        ...(dashboardData?.additional_properties?.missing_records_details
          ?.length > 0
          ? Object.keys(
              getFormattedKeysPairs(
                dashboardData.additional_properties.missing_records_details[0]
                  ?.keys,
              ),
            ).map((key) => ({
              field: key,
            }))
          : []),
      ],
    },
    {
      groupId: "Resources",
      headerName: "Resources",
      headerAlign: "center",
      children: dashboardData?.additional_properties?.resource_prefixes.map(
        (key: any) => ({
          field: key,
        }),
      ),
    },
    {
      groupId: "Messages",
      headerName: "Messages",
      headerAlign: "center",
      children: [{ field: "message" }],
    },
    ...(dashboardData?.additional_properties?.missing_records_details?.length >
      0 &&
    dashboardData.additional_properties.missing_records_details[0]?.file_names
      ? [
          {
            groupId: "file_name",
            headerName: "File Names",
            headerAlign: "center" as GridAlignment,
            children: Object.keys(
              getFormattedKeysPairs(
                dashboardData.additional_properties.missing_records_details[0]
                  ?.file_names,
              ),
            ).map((key) => ({
              field: key,
            })),
          },
        ]
      : []),
  ];

  const getMissingColumns = (
    missing_records_details: any,
    resource_prefixes?: any,
  ) => {
    const resourceKeys = resource_prefixes ? resource_prefixes : [];

    const columns: any = Object.keys(
      getFormattedKeysPairs(missing_records_details[0]?.keys),
    ).map((item: any) => {
      return {
        field: item,
        headerName: getSanatizedCode(item),
        flex: 1,
        minWidth: 100,
        headerAlign: "center",
        align: "center",
        renderCell: (params: any) => {
          const regex = /;(?![\w\s])/g;
          const fileNames = Object.keys(params.row)
            .filter((key) => key.includes("_file_name"))
            .map((key) => params.row[key])
            .filter((fileName) => fileName);

          const fileNamesDisplay =
            fileNames.length > 0 ? (
              <div>
                <strong>File name(s):</strong>
                <br />
                {fileNames.map((fileName, index) => {
                  const tempElement = document.createElement("div");
                  tempElement.innerHTML = fileName;
                  const fileNamesText =
                    tempElement.textContent || tempElement.innerText;
                  const individualFileNames =
                    fileNamesText.split(/\.xlsx|\.xls/);
                  return individualFileNames.map((fileName, subIndex) => {
                    const trimmedFileName = fileName.trim();
                    if (trimmedFileName) {
                      return (
                        <li key={`${index}-${subIndex}`}>
                          {trimmedFileName}.xlsx
                        </li>
                      );
                    }
                    return null;
                  });
                })}
              </div>
            ) : null;
          return (
            <span className="text-ellipsis">
              <Tooltip
                title={
                  <Typography sx={{ fontSize: "0.875rem" }}>
                    <ul className="pl-20">{fileNamesDisplay}</ul>
                  </Typography>
                }
                placement="top"
                className="tooltip-ellipsis"
              >
                {params.value.replace(regex, "")}
              </Tooltip>
            </span>
          );
        },
      };
    });

    const resource_prifix_columns: any = resourceKeys.map((item: any) => {
      return {
        field: item,
        headerName: item,
        headerAlign: "center",
        align: "center",
        flex: 1,
        renderCell: (params: any) => {
          // return params.row[item] ? (
          //   <IconCheckCircleIconGreenSvg width={21} height={21} />
          // ) : (
          //   <IconCrossCircleIconSvg width={21} height={21} />
          // );

          if (params.row[item] === "truepositive") {
            return <IconCheckCircleIconGreenSvg width={21} height={21} />;
          }
          if (params.row[item] === "secondaryfulfilled") {
            const secondaryResourceName = getSecondaryMergeResourceName(
              params.row[SECONDARY_MERGE_RESOURCES_KEY],
              item,
            );
            return (
              <Tooltip
                title={
                  <Typography sx={{ fontSize: "0.875rem" }}>
                    {`Fulfilled by secondary resource : ${secondaryResourceName}`}
                  </Typography>
                }
                placement="top"
                arrow
              >
                <span>
                  <IconSecondaryResourceSvg width={21} height={21} />
                </span>
              </Tooltip>
            );
          }
          if (params.row[item] === "falsepositive") {
            return (
              <>
                <IconFalsePositive />
              </>
            );
          }
          if (params.row[item] === "falsenegative") {
            return <IconCrossCircleIconSvg width={21} height={21} />;
          }
        },
      };
    });
    setColumnsData((prev: any) => ({
      ...prev,
      missingRecords: [
        ...columns,
        ...resource_prifix_columns,
        {
          field: "message",
          headerName: "Message",
          flex: 1,
          minWidth: 350,
          headerAlign: "center",
          renderCell: (params: any) => {
            const regex = /;(?![\w\s])/g;
            return (
              <span className="text-ellipsis">
                <Tooltip
                  title={
                    <Typography sx={{ fontSize: "0.875rem" }}>
                      {params.value.replace(regex, "")}
                    </Typography>
                  }
                  placement="top"
                  className="tooltip-ellipsis"
                >
                  {params.value.replace(regex, "")}
                </Tooltip>
              </span>
            );
          },
        },
      ],
    }));
  };

  const processRows = (rows: any[]) => {
    if (!rows) return;
    return rows.map((row: any) => {
      const updatedRow = { ...row };

      Object.keys(updatedRow).forEach((key) => {
        if (typeof updatedRow[key] === "string") {
          if (
            /\.0$/.test(updatedRow[key]) &&
            !/\.0[1-9]/.test(updatedRow[key])
          ) {
            updatedRow[key] = updatedRow[key].slice(0, -2);
          }
        }
      });

      return updatedRow;
    });
  };

  const getMissingRows = (
    missing_records_details: any,
    resource_prefixes?: any,
  ) => {
    const rows: any = missing_records_details?.map((item: any, idx: any) => {
      return {
        id: idx,
        ...getFormattedKeysPairs(item?.keys, "missing"),
        ...getFormattedKeysPairs1(
          item?.missing_in,
          item?.false_positive_missings,
          resource_prefixes,
          "missing",
        ),
        message: item?.message,
        ...getFormattedKeysPairs2(item?.file_names, "missing"),
      };
    });
    const processedRows = processRows(rows);
    setRowsData((prev: any) => ({
      ...prev,
      missingRecords: processedRows,
    }));
  };

  useEffect(() => {
    const {
      comparison_rule_exec_details,
      missing_records_details,
      resource_prefixes,
    } = dashboardData?.additional_properties || {};
    // mismatched records
    if (comparison_rule_exec_details?.length) {
      getColumns(comparison_rule_exec_details);
      handelRowData(comparison_rule_exec_details);
    }
    // missing records
    if (missing_records_details && missing_records_details?.length > 0) {
      if (typeof missing_records_details[0] === "object") {
        if (resource_prefixes) {
          getMissingColumns(missing_records_details, resource_prefixes);
          getMissingRows(missing_records_details, resource_prefixes);
        } else {
          getMissingColumns(missing_records_details);
          getMissingRows(missing_records_details);
        }
      }
    }
  }, [dashboardData, selectedTab]);

  useEffect(() => {
    const handleHashNavigation = () => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          const addBoxShadow = setTimeout(() => {
            element.classList.add("box-shadow10");
          }, 1000);

          element.scrollIntoView({ behavior: "smooth" });

          const removeBoxShadow = setTimeout(() => {
            element.classList.remove("box-shadow10");
          }, 3000);

          return () => {
            clearTimeout(addBoxShadow);
            clearTimeout(removeBoxShadow);
          };
        }
      }
    };
    handleHashNavigation();
  }, [dashboardData]);

  const tabContent: any = {
    mismatched: (
      <>
        <div className="datatable-parent-container">
          <MismatchedRecords
            rows={rowsData?.mismatched || []}
            columns={columnsData?.mismatched || []}
            isLoading={isLoading}
            setMismatchedColumns={setMismatchedColumns}
            dashboardData={dashboardData}
          />
        </div>
        {dashboardData?.comparison_research_query_results &&
          dashboardData?.comparison_research_query_results !== null && (
            <Box sx={{ mt: 2 }}>
              <RootCauseAnalysis
                selectedColumns={mismatchedColumns}
                isLoading={isLoading}
                heading={"Research"}
                dashboardData={dashboardData}
              />
            </Box>
          )}
      </>
    ),
    missingRecords: (
      <>
        <div className="datatable-parent-container">
          <MissingRecords
            rows={rowsData?.missingRecords || []}
            columns={columnsData?.missingRecords || []}
            isLoading={isLoading}
            columnGroupingModel={columnGroupingModel}
            setMissingColumns={setMissingColumns}
            dashboardData={dashboardData}
          />
        </div>
        {dashboardData?.comparison_research_query_results &&
          dashboardData?.comparison_research_query_results !== null && (
            <Box sx={{ mt: 2 }}>
              <RootCauseAnalysis
                selectedColumns={missingColumns}
                isLoading={isLoading}
                heading={"Research"}
                dashboardData={dashboardData}
              />
            </Box>
          )}
      </>
    ),

    adhocQuery: (
      <Box className="adhock-query-accordion-wrapper">
        {<AdhocQueryDashboardTab dashboardData={dashboardData || []} />}
      </Box>
    ),
  };
  const isValidationExecDetails =
    dashboardData?.additional_properties?.validation_exec_details !== null &&
    dashboardData?.additional_properties?.validation_exec_details.length > 0
      ? true
      : false;
  const supportDocumentsPath =
    dashboardData?.additional_properties?.supporting_documents;

  const reqPath =
    dashboardData?.complete_execution_params?.rule_execution_request;
  const skipDuplicateRecords =
    reqPath?.request_body?.query_params?.skip_duplicate_records;
  const additionalInfoForAllResources =
    reqPath?.additional_info_for_all_resources;
  const resourceNames =
    dashboardData?.additional_properties?.validation_exec_details;

  const formattedData = reqPath?.request_body?.resource_data.map(
    (item: any, index: any) => {
      const {
        file_name,
        linked_service_code,
        connection_key,
        resource_path,
        resource_id,
        file_names = [],
        ...otherProps
      } = item || {};
      const fileNames = additionalInfoForAllResources.find(
        (additionalItem: any) => additionalItem?.resource_id === resource_id,
      )?.file_names;
      const resource_name = resourceNames.find(
        (rsItem: any) => rsItem?.resource_id === resource_id,
      )?.resource_name;
      return (
        <tr key={index}>
          <td>
            {resource_name} ({item?.resource_id})
          </td>
          <td>
            <div className="file-scroll">
              <div className="break-word w-240">
                {Array.isArray(fileNames) && fileNames.length > 0
                  ? fileNames.map((fileName: any, index: number) => (
                      <Box className="file-name-box" key={index}>
                        {fileName}
                      </Box>
                    ))
                  : "N/A"}
              </div>
            </div>
          </td>
          <td>
            {item?.linked_service_code ? item?.linked_service_code : "N/A"}
          </td>
          <td>{item?.connection_key ? item?.connection_key : "N/A"}</td>
          <td>
            <div className="break-word w-240">
              {item.resource_path
                ? item.resource_path.replace(/"/g, "")
                : "N/A"}
            </div>
          </td>
          <td>
            <span className="position-relative">
              <Tooltip
                componentsProps={{
                  tooltip: { className: "wide-tooltip w-380" },
                }}
                title={
                  <pre
                    style={{
                      whiteSpace: "pre-wrap",
                      margin: 0,
                      maxHeight: "200px",
                      overflowY: "auto",
                    }}
                  >
                    <React.Fragment>
                      <Typography color="inherit">
                        Additional Resource Info
                      </Typography>
                      <Typography>
                        {formattedJson(JSON.stringify(otherProps))}
                      </Typography>
                    </React.Fragment>
                  </pre>
                }
              >
                <InfoIcon
                  sx={{
                    position: "absolute",
                    top: "50%",
                    transform: "translateY(-50%)",
                    right: "-24px",
                    width: "16px",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            </span>
          </td>
        </tr>
      );
    },
  );

  const handleSecureDownload = async (filepath: string, fileName: string) => {
    if (downloadingFiles.has(filepath)) return; // Prevent duplicate downloads

    setDownloadingFiles((prev) => new Set(prev).add(filepath));

    try {
      await downloadFileSecurely(filepath, fileName, true);
    } catch (error) {
      console.error("Download failed:", error);
      // Error handling is done in the downloadFileSecurely function
    } finally {
      setDownloadingFiles((prev) => {
        const newSet = new Set(prev);
        newSet.delete(filepath);
        return newSet;
      });
    }
  };

  const getSecureReportPath = (path: string) => {
    if (path) {
      const { fileName } = getSecureValidationReportPath(path);
      return {
        downloadAction: () => handleSecureDownload(path, fileName),
        fileName,
      };
    }
    return null;
  };

  const ruleVariables =
    reqPath?.request_body?.inline_variables?.rule_variables || {};
  const resourceVariables =
    reqPath?.request_body?.inline_variables?.resource_variables || [];
  const researchQueryVariables =
    reqPath?.request_body?.inline_variables
      ?.comparison_research_query_variables || [];

  const adhocRecordCount = resolveAdhocQueryRecordCount({
    adhocQueries: dashboardData?.additional_properties?.adhoc_queries_result,
    isDetailedExecutionDataAvailable:
      dashboardData?.is_detailed_execution_data_available,
    summaryTotal:
      dashboardData?.additional_properties?.total_adhoc_queries_result_records,
  });

  const kpiMatched =
    dashboardData?.additional_properties?.total_matched_records ?? 0;
  const kpiMismatched =
    dashboardData?.additional_properties?.total_mismatched_records ?? 0;
  const kpiMissing =
    dashboardData?.additional_properties?.total_unique_missing_records ??
    dashboardData?.additional_properties?.total_missing_records ??
    0;
  const kpiTotalRecords =
    dashboardData?.additional_properties?.total_records ??
    kpiMatched + kpiMismatched + kpiMissing;
  const kpiSuccessRate =
    kpiTotalRecords > 0
      ? ((kpiMatched / kpiTotalRecords) * 100).toFixed(1)
      : "0.0";
  const kpiBorderColor = isDark
    ? darkModeTokens.border
    : scssTokens.inputBoxBorder;

  const kpiCards = [
    {
      label: "Total Records",
      value: formatNumberWithCommas(kpiTotalRecords),
      color: brand.blue,
      bg: isDark ? darkModeTokens.surface : blueScale[50],
    },
    {
      label: "Matched",
      value: formatNumberWithCommas(kpiMatched),
      color: brand.teal,
      bg: isDark ? "rgba(112,181,167,0.18)" : "rgba(112,181,167,0.12)",
    },
    {
      label: "Missing",
      value: formatNumberWithCommas(kpiMissing),
      color: isDark ? "#ef6e6e" : scssTokens.badgeDangerBg,
      bg: isDark ? "rgba(232,67,54,0.18)" : "rgba(232,67,54,0.10)",
    },
    {
      label: "Mismatched",
      value: formatNumberWithCommas(kpiMismatched),
      color: isDark ? "#ef6e6e" : scssTokens.badgeDangerBg,
      bg: isDark ? "rgba(232,67,54,0.12)" : "rgba(232,67,54,0.06)",
    },
    {
      label: "Adhoc Query",
      value:
        adhocRecordCount === null
          ? "-"
          : formatNumberWithCommas(adhocRecordCount),
      color: brand.teal,
      bg: isDark ? "rgba(112,181,167,0.18)" : "rgba(112,181,167,0.12)",
    },
    {
      label: "Success Rate",
      value: `${kpiSuccessRate}%`,
      color: isDark ? brand.ice : brand.navy,
      bg: isDark ? darkModeTokens.surface : navyScale[100],
    },
  ];

  const missingCount =
    dashboardData?.additional_properties?.total_unique_missing_records ??
    dashboardData?.additional_properties?.total_missing_records ??
    null;
  const mismatchedCount =
    dashboardData?.additional_properties?.total_mismatched_records ?? null;
  const adhocCount = resolveAdhocQueryRecordCount({
    adhocQueries: dashboardData?.additional_properties?.adhoc_queries_result,
    isDetailedExecutionDataAvailable:
      dashboardData?.is_detailed_execution_data_available,
    summaryTotal:
      dashboardData?.additional_properties?.total_adhoc_queries_result_records,
  });

  const TAB_COLORS: Record<string, string> = {
    missingRecords: "#d32f2f",
    mismatched: "#e65100",
    adhocQuery: "#00796b",
  };

  const activeColor = TAB_COLORS[selectedTab] ?? "#1976d2";

  const tabLabel = (label: string, count: number | null, tabKey: string) => (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
      {label}
      {count !== null && count > 0 && (
        <Chip
          label={count}
          size="small"
          sx={{
            height: 18,
            fontSize: "0.7rem",
            fontWeight: 700,
            backgroundColor: TAB_COLORS[tabKey],
            color: "#fff",
            "& .MuiChip-label": { px: 0.75 },
          }}
        />
      )}
    </Box>
  );

  return (
    <>
      <Loader isLoading={isBackdropLoading} />
      <Box className="dashboard-title-group">
        <Stack
          direction="row"
          spacing={2.5}
          alignItems="center"
          flexWrap="wrap"
          divider={
            <Divider
              orientation="vertical"
              flexItem
              sx={{ mx: 0.5, borderColor: "divider" }}
            />
          }
          sx={{ width: "100%", rowGap: 1.5 }}
        >
          <Box
            className="heading"
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 0.25,
              flex: "1 1 auto",
              minWidth: 0,
            }}
          >
            <Tooltip
              title={reqPath?.request_body?.execution_name || ""}
              placement="top"
              arrow
            >
              <Typography
                variant="h6"
                noWrap
                sx={{ fontWeight: 700, lineHeight: 1.3 }}
              >
                {reqPath?.request_body?.execution_name}
              </Typography>
            </Tooltip>
            <Stack
              direction="row"
              spacing={1}
              alignItems="center"
              flexWrap="wrap"
              divider={
                <Box
                  component="span"
                  sx={{ color: "text.disabled", lineHeight: 1 }}
                >
                  ·
                </Box>
              }
              sx={{ color: "text.secondary", rowGap: 0.25 }}
            >
              {(dashboardData?.run_name || dashboardData?.run_id) && (
                <Typography variant="body2" color="inherit">
                  Execution Group: {dashboardData?.run_name ?? "—"}
                  {dashboardData?.run_id ? ` (${dashboardData?.run_id})` : ""}
                </Typography>
              )}
              {getExecutionSubGroupName(
                dashboardData,
                executionSubGroupMap,
              ) && (
                <Typography variant="body2" color="inherit">
                  Execution Sub Group:{" "}
                  {getExecutionSubGroupName(
                    dashboardData,
                    executionSubGroupMap,
                  )}
                </Typography>
              )}
              {dashboardData?.execution_time && (
                <Typography variant="body2" color="inherit">
                  {getDateFromTimestamp(dashboardData?.execution_time)}{" "}
                  {getFormattedTime(dashboardData?.execution_time)}
                </Typography>
              )}
              {dashboardData?.additional_properties?.total_time != null && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.5,
                    color: "inherit",
                  }}
                >
                  <IconWatchSvg />
                  <Typography variant="body2" color="inherit">
                    {getTimeInHHMMSS(
                      dashboardData?.additional_properties?.total_time,
                    )}
                  </Typography>
                </Box>
              )}
            </Stack>
          </Box>

          {dashboardData &&
            dashboardData?.additional_properties &&
            !dashboardData?.additional_properties?.are_all_errors_stored && (
              <div className="popover-box">
                <div className="db-info-icon" onClick={handleDbInfoClick}>
                  <IconDbInfo />
                </div>
                <Popover
                  open={isDbInfoPopoverOpen}
                  anchorEl={dbInfoAnchorEl}
                  onClose={handleDbInfoClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                  }}
                  slotProps={{
                    paper: {
                      className: "db-info-popover",
                    },
                  }}
                >
                  <Box className="db-error-popover-body">
                    <div className="title">Records summary</div>

                    <ul>
                      <li>
                        <div className="item-parent">
                          <div className="item1">Total mismatched : </div>
                          <div className="item2">
                            Generated &nbsp; - &nbsp;
                            {formatNumberWithCommas(
                              dashboardData?.additional_properties
                                ?.total_mismatched_records_for_all_columns || 0,
                            )}
                          </div>

                          <div className="item3">
                            Recorded &nbsp; - &nbsp;
                            {formatNumberWithCommas(
                              dashboardData?.additional_properties
                                ?.total_mismatched_records_stored_in_db || 0,
                            )}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="item-parent">
                          <div className="item1">Total missing : </div>
                          <div className="item2">
                            Generated &nbsp; - &nbsp;
                            {formatNumberWithCommas(
                              dashboardData?.additional_properties
                                ?.total_missing_records || 0,
                            )}
                          </div>
                          <div className="item3">
                            Recorded &nbsp; - &nbsp;
                            {formatNumberWithCommas(
                              dashboardData?.additional_properties
                                ?.total_missing_records_stored_in_db || 0,
                            )}
                          </div>
                        </div>
                      </li>
                      <li>
                        <div className="item-parent">
                          <div className="item1">
                            Total adhoc queries results :
                          </div>
                          <div className="item2">
                            Generated &nbsp; - &nbsp;
                            {formatNumberWithCommas(
                              dashboardData?.additional_properties
                                ?.total_adhoc_queries_result_records || 0,
                            )}
                          </div>
                          <div className="item3">
                            Recorded &nbsp; - &nbsp;
                            {formatNumberWithCommas(
                              dashboardData?.additional_properties
                                ?.total_adhoc_queries_result_records_stored_in_db ||
                                0,
                            )}
                          </div>
                        </div>
                      </li>
                    </ul>
                  </Box>
                </Popover>
              </div>
            )}

          {dashboardData && (
            <Stack direction="row" spacing={1} alignItems="center">
              <label
                className={`badges badge-base ${
                  dashboardData?.job_status === "completed"
                    ? "badge-success"
                    : "badge-error"
                }`}
              >
                {dashboardData?.job_status === "completed"
                  ? "Completed"
                  : "Completed With Errors"}
              </label>
            </Stack>
          )}

          {canRuleExecution && (
            <Stack direction="row" spacing={1.5} alignItems="center">
              <Button
                className="btn-orange btn-dark btn-sm plus-btn-sm"
                onClick={() =>
                  navigate(
                    `/rules/${dashboardData?.domain_id}/re-run-rule-execution/${dashboardData?.rule_id}?re-run=true&execution-id=${dashboardData?.id}&run-id=${dashboardData?.run_id}&run-name=${dashboardData?.run_name}&execution-sub-group-id=${dashboardData?.execution_sub_group_id}&execution-sub-group-code=${dashboardData?.execution_sub_group_code}`,
                  )
                }
              >
                <IconReRunWhite /> &nbsp; ReRun
              </Button>
            </Stack>
          )}
        </Stack>
      </Box>
      {dashboardData && (
        <Paper
          elevation={0}
          sx={{
            display: "flex",
            flexWrap: "wrap",
            mb: 2,
            border: `1px solid ${kpiBorderColor}`,
            borderRadius: 1,
            overflow: "hidden",
          }}
        >
          {kpiCards.map((kpi, idx) => (
            <Box
              key={kpi.label}
              sx={{
                flex: "1 1 120px",
                px: 3,
                py: 2,
                textAlign: "center",
                borderRight:
                  idx < kpiCards.length - 1
                    ? `1px solid ${kpiBorderColor}`
                    : "none",
                borderTop: `3px solid ${kpi.color}`,
                backgroundColor: kpi.bg,
              }}
            >
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ textTransform: "uppercase", letterSpacing: 0.5 }}
              >
                {kpi.label}
              </Typography>
              <Typography
                variant="h5"
                sx={{ fontWeight: 700, color: kpi.color, lineHeight: 1.2 }}
              >
                {kpi.value}
              </Typography>
            </Box>
          ))}
        </Paper>
      )}

      <Paper
        className="accordion-panel"
        elevation={0}
        sx={getPremiumCardSx(mode)}
      >
        <Accordion defaultExpanded className="heading-bold">
          <AccordionSummary
            aria-controls="dataset-summary-content"
            id="dataset-summary-header"
            expandIcon={<GridExpandMoreIcon />}
          >
            <h4>Dataset Summary</h4>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container rowSpacing={2} columnSpacing={2} marginBottom="8px">
              {isValidationExecDetails ? (
                dashboardData?.additional_properties?.validation_exec_details?.map(
                  (item: any, index: any) => {
                    let duplicateRecords =
                      item?.validation_result?.additional_properties
                        ?.total_duplicate_records || 0;
                    const localPieData = { ...pieData };

                    localPieData.resource_name = item.resource_name;
                    localPieData.total_null_key_records =
                      item?.validation_result?.additional_properties
                        ?.filtered_records_by_null_values_in_unique_keys || 0;
                    localPieData.resource_id = item.resource_id;
                    localPieData.domain_id = item?.validation_result?.domain_id;
                    localPieData.total_records = item.total_records_count;
                    localPieData.total_common_records =
                      item.total_common_records;
                    localPieData.total_mismatched_records =
                      item.total_mismatched_records;
                    localPieData.total_missing_records =
                      item.missing_records_count;
                    localPieData.total_duplicate_records = duplicateRecords;
                    localPieData.total_unique_records = item.unique_records;
                    localPieData.filtered_records_by_resource_filters =
                      item?.validation_result?.additional_properties
                        ?.filtered_records_by_resource_filters || 0;
                    localPieData.total_matched_records =
                      dashboardData?.additional_properties
                        ?.total_common_records -
                      dashboardData?.additional_properties
                        ?.total_mismatched_records;
                    localPieData.false_positive_missing_records_count =
                      item?.false_positive_missing_records_count || 0;
                    localPieData.filtered_records_by_rule_filters =
                      item.filtered_records_by_rule_filters || 0;
                    localPieData.countsData = {
                      match:
                        dashboardData?.additional_properties
                          ?.total_matched_records,
                      mismatch:
                        dashboardData?.additional_properties
                          ?.total_mismatched_records,
                      missing: item.missing_records_count,
                      duplicate: duplicateRecords,
                      total: item.total_records_count || 0,
                    };
                    localPieData.key = { index };
                    localPieData.are_all_errors_stored =
                      item?.validation_result?.additional_properties?.are_all_errors_stored;
                    localPieData.total_validation_errors =
                      item?.validation_result?.additional_properties
                        ?.total_validation_errors || 0;
                    localPieData.total_validation_errors_stored_in_db =
                      item?.validation_result?.additional_properties
                        ?.total_validation_errors_stored_in_db || 0;
                    localPieData.total_duplicate_records_stored_in_db =
                      item?.validation_result?.additional_properties
                        ?.total_duplicate_records_stored_in_db || 0;
                    localPieData.filtered_records_by_null_values_in_unique_keys =
                      item?.validation_result?.additional_properties
                        ?.filtered_records_by_null_values_in_unique_keys || 0;
                    localPieData.filtered_records_by_null_values_in_unique_keys_stored_in_db =
                      item?.validation_result?.additional_properties
                        ?.filtered_records_by_null_values_in_unique_keys_stored_in_db ||
                      0;
                    localPieData.total_cross_field_validation_results =
                      item?.validation_result?.additional_properties
                        ?.total_cross_field_validation_results || 0;
                    localPieData.total_cross_field_validation_results_stored_in_db =
                      item?.validation_result?.additional_properties
                        ?.total_cross_field_validation_results_stored_in_db ||
                      0;

                    return (
                      <Grid
                        item
                        xs={12}
                        sm={12}
                        md={4}
                        lg={4}
                        xl={4}
                        key={index}
                      >
                        <ComparisonDashboardCard
                          pieData={localPieData}
                          domainId={dashboardData?.domain_id}
                          skipDuplicateRecords={skipDuplicateRecords}
                          totalMatchRecords={
                            dashboardData?.additional_properties
                              ?.total_matched_records
                          }
                        />
                      </Grid>
                    );
                  },
                )
              ) : (
                <Grid item xs={12} sm={12} md={4} lg={4}>
                  <ComparisonDashboardCard
                    pieData={pieData}
                    totalMatchRecords={
                      dashboardData?.additional_properties
                        ?.total_matched_records
                    }
                  />
                </Grid>
              )}
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Paper>
      <Incidents
        currentResultId={currentRuleResultId || ""}
        currentIncidentData={currentRuleIncidentData ?? []}
        setIsLoading={setIsLoading}
        setIsTriggereBtnPressed={setIsTriggereBtnPressed}
        setIsCommentBtnPressed={setIsCommentBtnPressed}
      />
      <Paper
        className="accordion-panel"
        elevation={0}
        sx={getPremiumCardSx(mode)}
      >
        <Accordion defaultExpanded className="heading-bold">
          <AccordionSummary
            aria-controls="issue-details-content"
            id="issue-details-header"
            expandIcon={<GridExpandMoreIcon />}
          >
            <h4>Issue Details</h4>
          </AccordionSummary>
          <AccordionDetails sx={{ paddingTop: "16px" }}>
            <Grid container className="tabs-with-butttons">
              <Grid item xs>
                <Tabs
                  value={selectedTab}
                  onChange={handleChange}
                  className="mui-tabs no-t-lr-radius min-height-0 alternative-1"
                  TabIndicatorProps={{
                    style: { backgroundColor: activeColor },
                  }}
                  sx={{
                    "& .MuiTab-root.Mui-selected": { color: activeColor },
                  }}
                >
                  <Tab
                    value="missingRecords"
                    label={tabLabel(
                      "Missing Records",
                      missingCount,
                      "missingRecords",
                    )}
                  />
                  <Tab
                    value="mismatched"
                    label={tabLabel(
                      "Mismatched Rows",
                      mismatchedCount,
                      "mismatched",
                    )}
                  />
                  <Tab
                    value="adhocQuery"
                    label={tabLabel("Adhoc Query", adhocCount, "adhocQuery")}
                  />
                </Tabs>
              </Grid>
              {selectedTab === "missingRecords" ||
              selectedTab === "mismatched" ? (
                <Grid item className="buttons-group">
                  <Button className="btn-blue btn-orange btn-sm">
                    <IconBoltType /> Action
                  </Button>
                  {canEditRuleExecutionIssues && (
                    <Button className="btn-blue btn-orange btn-sm" disabled>
                      Update Issue
                    </Button>
                  )}

                  <Button
                    className="btn-blue btn-orange btn-sm"
                    onClick={() => {
                      navigate("/incident-reporting-rerun-report");
                    }}
                  >
                    Historical Trail
                  </Button>
                </Grid>
              ) : null}
            </Grid>

            <Box>{tabContent[selectedTab]}</Box>
          </AccordionDetails>
        </Accordion>
      </Paper>
      {reqPath?.request_body && (
        <>
          <Paper
            className="accordion-panel"
            elevation={0}
            sx={getPremiumCardSx(mode)}
          >
            <Accordion
              className="heading-bold"
              sx={{ my: 0, "&.Mui-expanded": { margin: 0 } }}
            >
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
                expandIcon={<GridExpandMoreIcon />}
              >
                <h4>Supporting Documents </h4>
              </AccordionSummary>
              <AccordionDetails sx={{ paddingTop: "16px" }}>
                <CustomAccordion
                  expandId="panel2d-header-support-documents"
                  title="Rule Execution Report"
                  isEnabled={true}
                  topMargin={1}
                >
                  <table className="custom-table">
                    <tbody>
                      <tr>
                        <th className="w-180">Report Type </th>
                        <th>Report Location </th>
                      </tr>

                      <tr>
                        <td width="180">Rule Execution Report</td>
                        <td>
                          {dashboardData?.additional_properties
                            ?.supporting_documents?.rule_execution_report
                            ? (() => {
                                const reportPath = getSecureReportPath(
                                  supportDocumentsPath?.rule_execution_report,
                                );
                                const isDownloading = downloadingFiles.has(
                                  supportDocumentsPath?.rule_execution_report,
                                );

                                return (
                                  <Box className="word-break-all row-hr">
                                    <Box
                                      sx={{
                                        color: "black",
                                        cursor: isDownloading
                                          ? "not-allowed"
                                          : "pointer",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                      }}
                                      onClick={() =>
                                        !isDownloading &&
                                        reportPath?.downloadAction()
                                      }
                                    >
                                      {isDownloading && (
                                        <CircularProgress size={16} />
                                      )}
                                      {reportPath?.fileName}
                                    </Box>
                                  </Box>
                                );
                              })()
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td width="180">
                          Comparison Research Query Result Reports
                        </td>
                        <td>
                          {supportDocumentsPath
                            ?.comparison_research_query_result_reports?.length >
                          0
                            ? supportDocumentsPath.comparison_research_query_result_reports.map(
                                (researchItem: any) => {
                                  const reportPath =
                                    getSecureReportPath(researchItem);
                                  const isDownloading =
                                    downloadingFiles.has(researchItem);

                                  return (
                                    <Box
                                      key={researchItem}
                                      className="word-break-all row-hr"
                                    >
                                      <Box
                                        sx={{
                                          color: "black",
                                          cursor: isDownloading
                                            ? "not-allowed"
                                            : "pointer",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 1,
                                        }}
                                        onClick={() =>
                                          !isDownloading &&
                                          reportPath?.downloadAction()
                                        }
                                      >
                                        {isDownloading && (
                                          <CircularProgress size={16} />
                                        )}
                                        {reportPath?.fileName}
                                      </Box>
                                    </Box>
                                  );
                                },
                              )
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>Filter Records Report</td>
                        <td>
                          {supportDocumentsPath?.filter_records_report !==
                            null &&
                          supportDocumentsPath?.filter_records_report.length > 0
                            ? supportDocumentsPath?.filter_records_report.map(
                                (filterItem: string, index: number) => {
                                  const reportPath =
                                    getSecureReportPath(filterItem);
                                  const isDownloading =
                                    downloadingFiles.has(filterItem);

                                  return (
                                    <Box
                                      key={index}
                                      className="word-break-all row-hr"
                                    >
                                      <Box
                                        sx={{
                                          color: "black",
                                          cursor: isDownloading
                                            ? "not-allowed"
                                            : "pointer",
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 1,
                                        }}
                                        onClick={() =>
                                          !isDownloading &&
                                          reportPath?.downloadAction()
                                        }
                                      >
                                        {isDownloading && (
                                          <CircularProgress size={16} />
                                        )}
                                        {reportPath?.fileName}
                                      </Box>
                                    </Box>
                                  );
                                },
                              )
                            : "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <td>Adhoc Query Reports</td>
                        <td>
                          {supportDocumentsPath?.adhoc_query_result_reports !==
                          null
                            ? supportDocumentsPath.adhoc_query_result_reports.filter(
                                (filterItem: any) => filterItem !== null,
                              ).length > 0
                              ? supportDocumentsPath.adhoc_query_result_reports
                                  .filter(
                                    (filterItem: any) => filterItem !== null,
                                  ) // Filter again for rendering
                                  .map((filterItem: string, index: number) => {
                                    const reportPath =
                                      getSecureReportPath(filterItem);
                                    const isDownloading =
                                      downloadingFiles.has(filterItem);

                                    return (
                                      <Box
                                        key={index}
                                        className="word-break-all row-hr"
                                      >
                                        <Box
                                          sx={{
                                            color: "black",
                                            cursor: isDownloading
                                              ? "not-allowed"
                                              : "pointer",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: 1,
                                          }}
                                          onClick={() =>
                                            !isDownloading &&
                                            reportPath?.downloadAction()
                                          }
                                        >
                                          {isDownloading && (
                                            <CircularProgress size={16} />
                                          )}
                                          {reportPath?.fileName}
                                        </Box>
                                      </Box>
                                    );
                                  })
                              : "N/A"
                            : "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </CustomAccordion>

                {isValidationExecDetails &&
                  dashboardData?.additional_properties?.validation_exec_details?.map(
                    (item: any, index: any) => {
                      const supportingDocuments =
                        item?.validation_result?.additional_properties
                          ?.supporting_documents;
                      return (
                        supportingDocuments && (
                          <ResourceSupportDocuments
                            key={index}
                            title={`${item?.resource_name}(${item?.resource_id})`}
                            documents={supportingDocuments}
                          />
                        )
                      );
                    },
                  )}
              </AccordionDetails>
            </Accordion>
          </Paper>
          <Paper
            className="accordion-panel"
            elevation={0}
            sx={{ ...getPremiumCardSx(mode), mt: 1 }}
          >
            <Accordion className="heading-bold">
              <AccordionSummary
                aria-controls="panel2d-content"
                id="panel2d-header"
                expandIcon={<GridExpandMoreIcon />}
              >
                <h4>Comparison Parameters </h4>
              </AccordionSummary>
              <AccordionDetails sx={{ paddingTop: "16px" }}>
                <table className="custom-table">
                  <tbody>
                    <tr>
                      <th>Resource Name (Resource ID)</th>
                      <th>File Name</th>
                      <th>Connection Type Code</th>
                      <th>Connection Key</th>
                      <th>Resource Location</th>
                      <th>Additional Resource Info</th>
                    </tr>
                    {formattedData}
                  </tbody>
                </table>
              </AccordionDetails>
            </Accordion>
          </Paper>
        </>
      )}
      {((dashboardData &&
        reqPath?.request_body &&
        reqPath?.request_body?.inline_variables &&
        Object.keys(ruleVariables).length > 0) ||
        resourceVariables.length > 0 ||
        Object.keys(researchQueryVariables).length > 0) && (
        <Paper
          className="accordion-panel"
          elevation={0}
          sx={getPremiumCardSx(mode)}
        >
          <Accordion className="heading-bold">
            <AccordionSummary
              aria-controls="panel1d-content"
              id="panel1d-header"
              expandIcon={<GridExpandMoreIcon />}
            >
              Variables
            </AccordionSummary>
            <AccordionDetails sx={{ paddingTop: "16px" }}>
              <Grid container spacing={2.5}>
                {resourceVariables.length > 0 && (
                  <Grid item xs>
                    <h3 className="m-0 mb-2">{"Resource Variables"}</h3>
                    {resourceVariables.map((item: any) => {
                      const resourceName =
                        dashboardData?.rule_exec_parameters?.resource_details.find(
                          (resItem: any) =>
                            resItem.resource_id === item?.resource_id,
                        )?.resource_name;
                      return (
                        <div
                          key={item?.resource_id}
                          className="text-box-card box-card-variables full-radius"
                        >
                          <h3>{resourceName}</h3>

                          <table className="inline-variables-table">
                            <tbody>
                              {item?.resource_vars &&
                                Object.entries(item?.resource_vars).length >
                                  0 &&
                                Object.entries(item?.resource_vars).map(
                                  ([key, value]: any) => (
                                    <tr key={`${item.resource_id}_${key}`}>
                                      <td>
                                        <div className="inner-column">
                                          <div className="label">
                                            <strong>{key}</strong>
                                            <span className="required-asterisk">
                                              *
                                            </span>
                                            :
                                          </div>
                                          <input
                                            className={`form-control-1 read-only`}
                                            value={value}
                                            name={`${key}_${item.resource_id}`}
                                            title={`inlineVariables[${key}_${item.resource_id}]`}
                                            readOnly
                                          />
                                        </div>
                                      </td>
                                    </tr>
                                  ),
                                )}
                            </tbody>
                          </table>
                        </div>
                      );
                    })}
                  </Grid>
                )}
                {Object.keys(ruleVariables).length > 0 && (
                  <Grid item xs>
                    <h3 className="m-0 mb-2">{"Rule Variables"}</h3>

                    <table className="inline-variables-table">
                      <tbody>
                        {Object.keys(ruleVariables).map(
                          (key: string, index: number) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <div className="inner-column">
                                    <div className="label">
                                      <strong>{key}</strong>
                                      <span className="required-asterisk">
                                        *
                                      </span>
                                      :
                                    </div>
                                    <input
                                      className="form-control-1 read-only"
                                      value={ruleVariables[key]}
                                      name={key}
                                      title={ruleVariables[key]}
                                      readOnly
                                    />
                                  </div>
                                </td>
                              </tr>
                            );
                          },
                        )}
                      </tbody>
                    </table>
                  </Grid>
                )}

                {Object.keys(researchQueryVariables).length > 0 && (
                  <Grid item xs>
                    <h3 className="m-0 mb-2">{"Research Query Variables"}</h3>

                    <table className="inline-variables-table">
                      <tbody>
                        {Object.keys(researchQueryVariables).map(
                          (key: string, index: number) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <div className="inner-column">
                                    <div className="label">
                                      <strong>{key}</strong>
                                      <span className="required-asterisk">
                                        *
                                      </span>
                                      :
                                    </div>
                                    <input
                                      className="form-control-1 read-only"
                                      value={researchQueryVariables[key]}
                                      name={key}
                                      title={researchQueryVariables[key]}
                                      readOnly
                                    />
                                  </div>
                                </td>
                              </tr>
                            );
                          },
                        )}
                      </tbody>
                    </table>
                  </Grid>
                )}
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Paper>
      )}
    </>
  );
};

export default ComparisonDetailedExecutionDashboard;

const MismatchedRecords = ({
  rows,
  columns,
  isLoading,
  setMismatchedColumns,
  dashboardData,
}: any) => {
  const { mode } = useThemeMode();
  const isDark = mode === "dark";
  return (
    <Box className="position-relative">
      {rows && rows.length !== 0 ? (
        <Fade in timeout={300}>
          <Box>
            <RulesListDataTable
              dataRows={rows}
              dataColumns={columns}
              loading={isLoading}
              className="dataTable datagridHeaderColumn no-radius pt-0 bdr-top-0 datatable-column-sep checkbox-result-column pinnedColumnHeaders-bg-height hide-progress-icon"
              disableColumnFilter={false}
              tableHeight={180}
              setResultColumns={setMismatchedColumns}
              checkboxSelection={rows.length > 0 ? true : false}
              singlePageMaxHeightDiff={262}
              disableColumnPinning={false}
              variant="premium"
              resourcePrefixes={
                dashboardData?.additional_properties?.resource_prefixes
              }
            />
          </Box>
        </Fade>
      ) : (
        <Box
          className="adhock-query-accordion-wrapper"
          sx={{
            paddingTop: "24px",
            paddingBottom: "24px",
            display: "flex",
            justifyContent: "center",
            borderTop: "none",
            backgroundColor: isDark
              ? darkModeTokens.surfaceInset
              : "transparent",
            color: "text.secondary",
          }}
        >
          No data available
        </Box>
      )}
    </Box>
  );
};

const MissingRecords = ({
  rows,
  columns,
  isLoading,
  columnGroupingModel,
  setMissingColumns,
  dashboardData,
}: any) => {
  const { mode } = useThemeMode();
  const isDark = mode === "dark";
  return (
    <Box className="position-relative">
      {rows && rows.length !== 0 ? (
        <Fade in timeout={300}>
          <Box>
            <RulesListDataTable
              dataRows={rows}
              dataColumns={columns}
              loading={isLoading}
              className="dataTable datagridHeaderColumn no-radius pt-0 bdr-top-0 datatable-column-sep checkbox-result-column pinnedColumnHeaders-bg-height hide-progress-icon"
              disableColumnFilter={true}
              tableHeight={180}
              disableColumnReorder={true}
              columnGroupingModel={columnGroupingModel}
              setResultColumns={setMissingColumns}
              checkboxSelection={rows.length > 0 ? true : false}
              singlePageMaxHeightDiff={262}
              disableColumnPinning={false}
              variant="premium"
              resourcePrefixes={
                dashboardData?.additional_properties?.resource_prefixes
              }
            />
          </Box>
        </Fade>
      ) : (
        <Box
          className="adhock-query-accordion-wrapper"
          sx={{
            paddingTop: "24px",
            paddingBottom: "24px",
            display: "flex",
            justifyContent: "center",
            borderTop: "none",
            backgroundColor: isDark
              ? darkModeTokens.surfaceInset
              : "transparent",
            color: "text.secondary",
          }}
        >
          No data available
        </Box>
      )}
    </Box>
  );
};
